/**
 * Page router
 * 
 */

import React from 'react';
import Prismic from 'prismic-javascript';

// Functions

import Helpers from '../../utils/functions/helpers';

// Layout

import Article from '../layout/article/article';
import Microdata from '../layout/microdata/microdata';
import Theme from '../layout/theme/theme';
import Hero from '../layout/hero/hero';

// Components

import Meta from '../../components/meta/meta';
import Sections from '../../components/sections/sections';
import Contents from '../../components/contents/contents';

// Forms

import Contact from '../../components/forms/contact';

// Pages

import NotFound from './404';
import Loading from './loading';

export default class Page extends React.Component {

	state = {

		doc: null,
		device: null,
		template: null,
		settings: null,
		notFound: false
	}

	componentWillMount() {
		
		this.fetchPage(this.props);
	}

	componentWillReceiveProps(props) {
		
		this.fetchPage(props);
	}

	componentDidUpdate(prevProps) {

		if (this.props.location !== prevProps.location) {

			window.scrollTo(0, 0)
		}
	}

	fetchPage(props) {
		
		if (props.settings != null) {
			
			const { settings, device } = props;
			const url = props.match.params.uid === undefined ? '' : props.match.params.uid;
			
			props.cms.api.query(Prismic.Predicates.any('document.type', ['page', 'article', 'contact'])).then(function(response) {
				
				const doc = response.results.find(f => f.uid === url);
				
				if (doc) {
					
					// Renaming object keys to support scalable templates
					Helpers.renameObjectKeys(doc.data.body);

					this.setState({ doc: doc, settings: settings, device: device, template: doc.type });
				}
				else {

					this.setState({ notFound: !doc });
				}
				
			}.bind(this));
		}
		
		return null;
	}

	render() {
		
		if (this.state.doc) {
			
			const { data } = this.state.doc;
			const { settings, template, device } = this.state;
			
			if (template === 'page') {
				
				return (

					<React.Fragment>

						<Meta data={data} settings={settings}></Meta>
						<Theme theme={data.theme_class}></Theme>
						
						<Article layout="full">

							<Hero layout="bubble" style={data.hero_style}></Hero>
							<Sections data={data}></Sections>
							
						</Article>
					
					</React.Fragment>
				);
			}
			else if (template === 'article') {

				return (

					<React.Fragment>

						<Meta data={data} settings={settings}></Meta>
						<Theme theme={data.theme_class}></Theme>
						
						<Article layout="full">

							<Hero layout="bubble" style={data.hero_style}></Hero>

							<div className="article">

								<div className="content container">
									<div className="content-full">

										<h1>{data.title[0].text}</h1>
										{ !! data.lead && <p className="lead">{data.lead}</p> }

										<Contents data={data}></Contents>

									</div>
								</div>
								
							</div>

							<Microdata render="article" article={this.state.doc} settings={settings}></Microdata>

						</Article>
					
					</React.Fragment>
				);
			}
			else if (template === 'contact') {
				
				return (

					<React.Fragment>

						<Meta data={data} settings={settings}></Meta>
						<Theme theme={data.theme_class}></Theme>
						
						<Article layout="full">

							<Hero layout="bubble" style={data.hero_style}></Hero>

							<div className="section section-overflow">
								<div className="container">

									<h1>{data.title[0].text}</h1>
									{ !! data.lead && <p className="lead">{data.lead}</p> }

									<Contact settings={settings} device={device}></Contact>						

								</div>
							</div>
							
						</Article>
					
					</React.Fragment>
				);
			}
			else {

				return <NotFound />;
			}
		}
		else if (this.state.notFound) {

			return <NotFound />;
		}

    	return <Loading />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/page.js